<template>
<!-- :navigate-to="[startingSlide || 0, false]" -->

	<div class="container-fluid px-0">
				<!-- Can determine if it is on mobile as well.  -->
		<component :is="link ? 'a' : 'div'" :href="(link!='') ? link : ''">
			<div class="col-12 overlay_text">
				<h1>{{overlay_text}}</h1>
			</div>
			<carousel
				:per-page-custom="numPerPage"
				:scrollPerPage="scroll_per_page"
				:loop="true"
				:mouse-drag="false"
				:paginationEnabled="false"
				:navigationEnabled="show_controls !== undefined ? show_controls : true"
				:autoplay="shouldAutoplay"
				:autoplayTimeout="autoplaySeconds"
				:autoplayHoverPause="true"
				@navigation-click="navigationClick"
			>
				<Slide v-for="(slide, index) in slides" :key="index">
					<img :src="slide.image.sizes['ct-extra-large']"/><!-- :height="slide.image.sizes['medium_large-height']" :width="slide.image.sizes['medium_large-width']" />-->
				</Slide>
			</carousel>
			<CustomButton 
				:link="center_button_link"
				class="sliderButton"
				v-if="ShowCenterButton"
			>
				{{center_button_text}}
			</CustomButton>
		</component>
	</div>
</template>

<script>
// Documentation https://github.com/SSENSE/vue-carousel
import { Carousel, Slide } from "vue-carousel";
import CustomButton from "@/components/buttons/CustomButton";

export default {
    name: "FullWidthSlider",
  components: {
    Carousel,
    Slide,
	CustomButton
  },
  props: [
    // "startingSlide",
    "autoplay", //number, 0 means no autoplay
    "slides",
    "slides_per_page",
		"slides_per_page_mobile",
    "scroll_per_page", // boolean, scroll per item or per page
    "show_controls", // show or hide slider controls
    "link",
	"overlay_text",
	"center_button_text",
	"center_button_link"
  ],
  data() {
    return {
      interactedWith: false,
      interactionTimeout: null
    };
  },
  mounted(){
    this.$nextTick(() => {
      window.dispatchEvent(new Event('resize')) //makes sure first image shows up in slider
    })
  },
  methods: {
    navigationClick() {
      //called when navigation clicked
      this.interactedWith = true;
      clearTimeout(this.interactionTimeout);
      //re-enable autoplay with delay after last interaction
      this.interactionTimeout = setTimeout(() => {
        this.interactedWith = false;
      }, 5000);
    }
  },
  computed: {
    shouldAutoplay() {
      let defaultAutoplay = this.autoplay === undefined ? true : this.autoplay != 0;
      return defaultAutoplay && !this.interactedWith;
    },
    autoplaySeconds(){
      return this.autoplay *1000
    },
	numPerPage(){
		if(this.slides_per_page_mobile !== undefined){
			return [[320,parseInt(this.slides_per_page_mobile)],[768,parseInt(this.slides_per_page)]]
		} else {
			return [[0, parseInt(this.slides_per_page)]] //width greater than 0 then set to slides per page
		}
	},
	ShowCenterButton() {
		return this.center_button_text != '';
	}
  }
};
</script>


<style lang="scss" scoped>

.VueCarousel{
  width: 100%;
  margin: 5px auto;
}

.VueCarousel::v-deep .VueCarousel-slide{
//   padding: 0 5px;
}

.overlay_text {
	position: absolute;
	z-index: 100;
	margin: 20px auto;
	h1 {
		color: $CTred;
		font-size: 3em;
		filter: drop-shadow(0 0 2px white);
	}
}

.VueCarousel-slide{
    text-align: center;
	overflow: hidden;
	// height: 40em;
	position: relative;
    img{
		width: 100%;
		height: auto;
		position: relative;
		// max-width: none !important;
		left: 50%;
		// min-height: 100%;
		top: 50%;
		transform: translateY(-50%) translateX(-50%);
    }
}

.VueCarousel::v-deep .VueCarousel-navigation {
	width: 100%;
	z-index: 120;
	position: absolute;
	height: 100%;
	.VueCarousel-navigation-prev {
		transform: translateY(-50%) translateX(100%);
		// color: #eee;
	}
	.VueCarousel-navigation-next {
		transform: translateY(-50%) translateX(-100%);
		// color: #999;
	}
}

.sliderButton {
	position: absolute;
	left: 50%;
	z-index: 130;
	bottom: 0;
	font-size: 1em;
	transform: translate(-50%, 35%);
	border: 2px #fff solid;
}

@include media-breakpoint-down(md) {
	.VueCarousel-slide{
		// max-height: 20em;
		img {
			min-height: 0;
			width: 100%;
		}
	}
	.sliderButton {
		// bottom: 30px;
		transform: translate(-50%,35%);
		width: 80%;
	}
}

@include media-breakpoint-down(sm) {
	.VueCarousel-slide{
		// max-height: 20em;
	}
	.sliderButton {
		transform: translate(-50%,50%);
		width: 80%;
	}
}

@include media-breakpoint-up(xl) {
	.VueCarousel-slide{
		max-height: 50em;
	}
}

</style>
